import React, { FC } from "react";
import { SvgIconProps } from "@mui/material";
import MuiLockIcon from "@mui/icons-material/Lock";

export const LockIcon: FC<SvgIconProps> = (props) => {
  return (
    <MuiLockIcon sx={{ fontSize: 14, color: "customGrey.medium" }} {...props} />
  );
};
